<template>
  <v-navigation-drawer
    :value="value"
    app
    dark
    temporary
    @input="$emit('input', $event)"
  >
    <router-link
      to="Top"
      tag="div"
    >
      <v-list-item link>
        <v-list-item-avatar>
          <v-icon>mdi-dip-switch</v-icon>
          <!-- CUSTOM IMAGE
          <v-img src="https://camo.githubusercontent.com/be384df72ff1748336f5927f7116e79a37cbe1639a5b7db162be2d7afe350f87/68747470733a2f2f63646e2e767565746966796a732e636f6d2f696d616765732f6c6f676f732f6c6f676f2e737667" />
          -->
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ $t('sidebar.sidebarTitle') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>

    <v-divider />

    <v-list dense>
      <router-link
        v-for="menu in menuItems"
        :key="menu.id"
        :to="menu.routerLink"
        tag="div"
      >
        <v-list-item link>
          <v-list-item-icon>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    menuItems () {
      return [
        { id: '1', routerLink: 'User', icon: 'fa-user', title: this.$t('sidebar.userManagement') },
        { id: '2', routerLink: 'ScanRecord', icon: 'fa-qrcode', title: this.$t('sidebar.scanRecord') }
      ]
    }
  }
}
</script>
